import {
  Button,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Input,
  StackProps,
  VStack,
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useState } from "react";
import * as yup from "yup";
import { FrontProfileInterface } from "../../constants/SupplierProfile";
import useCustomToast from "../../lib/useCustomToast";
import { axiosSupplier } from "../../utils/AxiosInstance";
import { CardSkeleton } from "../skeleton/CardSkeleton";

interface Props extends StackProps {
  data: FrontProfileInterface | undefined;
  loaded: boolean;
  onRefreshProfile: () => void;
}

export const TabSupplierProfile = ({
  data,
  loaded,
  onRefreshProfile,
  ...rest
}: Props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const toast = useCustomToast();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: data && data.name,
      companyName: data && data.company_name,
    },
    validationSchema: yup.object().shape({
      name: yup.string().required("Nama pemilik supplier harus diisi"),
      companyName: yup.string().required("Nama store harus diisi"),
    }),
    onSubmit: (values) => {
      setLoading(true);

      const request = {
        name: values.name,
        company_name: values.companyName,
      };

      axiosSupplier
        .put(`/v1/supplier/update-some-profile`, request)
        .then((res) => {
          onRefreshProfile();

          toast({
            title: res.data.message,
            status: "success",
          });
        })
        .catch((err) => {
          toast({
            description: err?.response?.data?.message || "",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <form
      id="profileSupplierForm"
      onSubmit={formik.handleSubmit}
      style={{ width: "100%" }}
    >
      <VStack w={"100%"} gap={6} align={"stretch"} {...rest}>
        <FormControl
          isInvalid={formik.errors.name && formik.touched.name ? true : false}
        >
          <FormLabel htmlFor="name">Nama Pemilik Toko</FormLabel>
          {!loaded ? (
            <CardSkeleton row={1} height={40} />
          ) : (
            <Input
              name="name"
              type="text"
              autoComplete="off"
              onChange={formik.handleChange}
              value={formik.values.name || ""}
            />
          )}
          <FormErrorMessage>{formik.errors.name}</FormErrorMessage>
        </FormControl>

        <FormControl
          isInvalid={
            formik.errors.companyName && formik.touched.companyName
              ? true
              : false
          }
        >
          <FormLabel htmlFor="companyName">Nama Toko</FormLabel>
          {!loaded ? (
            <CardSkeleton row={1} height={40} />
          ) : (
            <Input
              name="companyName"
              type="text"
              autoComplete="off"
              onChange={formik.handleChange}
              value={formik.values.companyName || ""}
            />
          )}
          <FormErrorMessage>{formik.errors.companyName}</FormErrorMessage>
        </FormControl>

        <Button
          w={"fit-content"}
          variant={"solid"}
          form="profileSupplierForm"
          isLoading={loading}
          loadingText="Loading"
          spinnerPlacement="start"
          isDisabled={loaded ? false : true}
          type="submit"
          colorScheme="red"
        >
          Atur Profil
        </Button>
      </VStack>
    </form>
  );
};
